import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryforceurbania() {

const cardData = {
keyword: "Luxury Force Urbania On Rent in Pune",
headingDescription: "Luxury Force Urbania On Rent in Pune is a comfortable group transportation option for corporate travel, weddings, airport transfers, family tours, outstation journeys, and special events. Ruturaj Enterprises offers luxury Urbania options in different seating capacities, making it easier for families, companies, wedding groups, and larger parties to travel together in a spacious and premium vehicle. With comfortable interiors, organized seating, luggage space, and professional driver support, Luxury Force Urbania is suitable for both local Pune travel and longer outstation journeys.",
topPlaces: [
{
title: "Pune International Airport",
description: "Pune International Airport is a frequent pickup and drop location for business travellers, families, wedding guests, and groups arriving or departing from the city. A luxury Urbania provides a coordinated airport transfer option when several passengers need to travel together with luggage."
},
{
title: "Hinjewadi IT Park",
description: "Hinjewadi is one of Pune's major corporate and technology hubs, making it a practical location for employee transportation, business meetings, conferences, and corporate events. Luxury Urbania can accommodate office groups travelling together between hotels, workplaces, and event venues."
},
{
title: "Koregaon Park",
description: "Koregaon Park is known for hotels, restaurants, premium venues, and social events, making it a useful pickup point for groups attending celebrations or corporate gatherings. A luxury Urbania helps larger parties travel together comfortably without coordinating multiple cars."
},
{
title: "Kharadi EON IT Park",
description: "Kharadi's business district attracts corporate travellers and employee groups throughout the year. Luxury Force Urbania can be arranged for office transfers, conferences, airport movement, team outings, and group transportation between hotels and corporate campuses."
},
{
title: "Baner",
description: "Baner has numerous hotels, restaurants, residential communities, and event venues that regularly require group transportation. A luxury Urbania is suitable for wedding functions, corporate programs, family gatherings, and planned local or outstation travel from this part of Pune."
},
{
title: "Wakad",
description: "Wakad provides convenient access toward Hinjewadi, Pimpri-Chinchwad, and major highways, making it a useful pickup area for groups travelling for business or leisure. Luxury Urbania offers a practical way for passengers to stay together during local and intercity journeys."
},
{
title: "Magarpatta City",
description: "Magarpatta City is an important business and residential destination in Pune and can generate requirements for employee movement, corporate events, airport transfers, and group outings. A premium Urbania provides comfortable transportation for organized group travel."
},
{
title: "Viman Nagar",
description: "Viman Nagar is located close to Pune Airport and has several hotels, offices, restaurants, and commercial destinations. Luxury Urbania transportation is useful for airport groups, corporate visitors, wedding guests, and families requiring convenient shared travel."
},
{
title: "Pimpri Chinchwad",
description: "Pimpri Chinchwad is a major industrial and residential region with frequent requirements for employee travel, corporate programs, family functions, and outstation trips. A higher-capacity luxury Urbania allows larger groups to travel together from the PCMC area."
},
{
title: "Kothrud",
description: "Kothrud is a well-connected residential area suitable as a pickup point for family tours, wedding groups, corporate travel, and outstation journeys. Luxury Force Urbania can provide a comfortable shared vehicle for groups starting their trip from western Pune."
}
],
services: [
{
name: "Luxury Force Urbania Rental Pune",
description: "Luxury Force Urbania rental in Pune provides a spacious and premium transportation solution for families, corporate groups, wedding parties, airport transfers, and outstation travellers. Vehicle capacity can be selected according to the group's passenger count and itinerary."
},
{
name: "Luxury Force Urbania Hire Pune",
description: "Luxury Force Urbania hire is suitable for customers looking for a dedicated premium vehicle with comfortable seating and professional driver support. It can be arranged for local Pune travel, events, airport movement, family functions, and longer road journeys."
},
{
name: "Luxury Force Urbania Booking Pune",
description: "Luxury Force Urbania booking in Pune allows groups to reserve a suitable vehicle in advance according to travel dates, passenger requirements, pickup location, and journey type. Advance planning is useful for weddings, corporate events, airport transfers, and peak travel periods."
},
{
name: "Luxury Urbania Traveller on Rent Pune",
description: "Luxury Urbania Traveller on rent provides comfortable group transportation for families, friends, business teams, and event guests. The spacious cabin and shared travel arrangement make it practical for both city journeys and longer outstation routes."
},
{
name: "Luxury Urbania Van Rental Pune",
description: "Luxury Urbania van rental is designed for groups requiring more space than standard cars or smaller vans. It is suitable for corporate transportation, family tours, wedding guest movement, airport transfers, and planned group road trips."
},
{
name: "Luxury 13 Seater Urbania Pune",
description: "Luxury 13 Seater Urbania is a practical option for smaller groups wanting a premium and spacious vehicle. It can be used for family travel, corporate meetings, airport transfers, weddings, sightseeing, and outstation journeys from Pune."
},
{
name: "Luxury 14 Seater Urbania Pune",
description: "Luxury 14 Seater Urbania provides additional passenger capacity while maintaining a comfortable group travel arrangement. It is suitable for wedding guests, office teams, family groups, airport transfers, and leisure trips starting from Pune."
},
{
name: "Luxury 17 Seater Urbania Pune",
description: "Luxury 17 Seater Urbania is suitable for larger families, corporate teams, wedding groups, and friends travelling together. The higher seating capacity helps keep the entire party in one vehicle while providing a convenient setup for longer journeys."
},
{
name: "Luxury 20 Seater Urbania Pune",
description: "Luxury 20 Seater Urbania is designed for larger groups requiring a high-capacity premium vehicle. It can be arranged for corporate events, wedding transportation, group tours, airport transfers, and outstation travel where keeping passengers together is important."
},
{
name: "Force Urbania for Outstation Pune",
description: "Force Urbania for outstation travel from Pune offers a comfortable group transportation option for destinations across Maharashtra and other nearby states. It can be planned for one-way trips, round trips, multi-day tours, and customized group itineraries."
},
{
name: "Luxury Urbania for Family Trip Pune",
description: "Luxury Urbania for family trips provides a convenient shared vehicle for relatives travelling together. Families can use the spacious vehicle for weekend holidays, temple visits, sightseeing tours, and longer road trips while keeping everyone together."
},
{
name: "Luxury Urbania for Group Travel Pune",
description: "Luxury Urbania for group travel is suitable for friends, relatives, clubs, social groups, and organized parties. A dedicated vehicle simplifies pickup coordination, luggage handling, route planning, and travel arrangements for larger groups."
},
{
name: "Luxury Urbania for Wedding Pune",
description: "Luxury Urbania for wedding transportation can be used for moving relatives, guests, bridesmaids, groomsmen, and family members between homes, hotels, ceremony venues, and reception locations. It provides a coordinated solution for wedding guest movement."
},
{
name: "Luxury Urbania for Corporate Events Pune",
description: "Luxury Urbania for corporate events is suitable for conferences, employee outings, business meetings, exhibitions, team programs, and company gatherings. Groups can travel together between offices, hotels, airports, and event venues with organized transportation."
},
{
name: "Luxury Urbania for Airport Pickup Pune",
description: "Luxury Urbania for airport pickup provides a convenient shared transfer for larger families, corporate teams, and groups arriving at Pune Airport. The spacious vehicle can accommodate passengers and travel luggage while reducing the need for several separate cars."
},
{
name: "Luxury Urbania Traveller Hire Pune",
description: "Luxury Urbania Traveller hire in Pune provides a dedicated vehicle for groups requiring comfortable local or intercity transportation. It can be arranged for weddings, corporate programs, family functions, airport transfers, and leisure tours."
},
{
name: "Luxury Force Urbania for Outstation Travel",
description: "Luxury Force Urbania for outstation travel is suitable for longer journeys where passengers prefer to travel together in a spacious premium vehicle. The service can support family holidays, corporate tours, wedding groups, pilgrimages, and multi-day road trips."
},
{
name: "Luxury Force Urbania Rental Near Me Pune",
description: "Luxury Force Urbania rental near Pune provides a convenient option for customers searching for a premium group vehicle close to their preferred pickup area. Availability can be planned around the required date, seating capacity, destination, and duration of travel."
},
{
name: "Luxury Urbania Booking in Pune",
description: "Luxury Urbania booking in Pune can be planned for local events, airport transfers, family tours, corporate transportation, weddings, and outstation journeys. Selecting the vehicle capacity in advance helps ensure a suitable arrangement for the complete group."
},
{
name: "Luxury Force Urbania Price Pune",
description: "Luxury Force Urbania Price Pune depends on factors such as seating capacity, travel distance, trip duration, route, local or outstation usage, and the selected itinerary. Customers can choose a suitable vehicle after discussing their travel requirements and group size."
}
],
tableData: [
["Luxury Force Urbania Rental Pune"],
["Luxury Force Urbania Hire Pune"],
["Luxury Force Urbania Booking Pune"],
["Luxury Urbania Traveller on Rent Pune"],
["Luxury Urbania Van Rental Pune"],
["Luxury 13 Seater Urbania Pune"],
["Luxury 14 Seater Urbania Pune"],
["Luxury 17 Seater Urbania Pune"],
["Luxury 20 Seater Urbania Pune"],
["Force Urbania for Outstation Pune"],
["Luxury Urbania for Family Trip Pune"],
["Luxury Urbania for Group Travel Pune"],
["Luxury Urbania for Wedding Pune"],
["Luxury Urbania for Corporate Events Pune"],
["Luxury Urbania for Airport Pickup Pune"],
["Luxury Urbania Traveller Hire Pune"],
["Luxury Force Urbania for Outstation Travel"],
["Luxury Force Urbania Rental Near Me Pune"],
["Luxury Urbania Booking in Pune"],
["Luxury Force Urbania Price Pune"]
],
whychoose: [
{
WhyChooseheading: "Premium Group Travel Experience",
WhyChoosedescription: "Luxury Force Urbania offers a spacious group travel environment that is suitable for passengers who want more comfort than a standard car or smaller vehicle. It works well for special occasions, family journeys, corporate programs, and extended road trips."
},
{
WhyChooseheading: "Multiple Seating Options",
WhyChoosedescription: "Different seating capacities make it easier to match the vehicle with the actual number of passengers. Groups can select from 13, 14, 17, or 20-seater options depending on their travel party, luggage requirements, and itinerary."
},
{
WhyChooseheading: "Ideal for Weddings and Events",
WhyChoosedescription: "Wedding guests and event attendees often need coordinated transportation between several locations. A luxury Urbania helps keep guests together while making movement between hotels, venues, reception locations, and other functions more organized."
},
{
WhyChooseheading: "Convenient Corporate Transportation",
WhyChoosedescription: "Corporate teams can use Luxury Force Urbania for conferences, employee outings, business meetings, exhibitions, airport transfers, and company events. Shared transportation simplifies group movement while providing a comfortable environment for longer journeys."
},
{
WhyChooseheading: "Suitable for Airport Transfers",
WhyChoosedescription: "Groups arriving at or departing from Pune Airport can use a luxury Urbania to travel together with their luggage. One dedicated vehicle can make airport transportation easier to coordinate for families, business teams, and larger groups."
},
{
WhyChooseheading: "Comfortable for Outstation Journeys",
WhyChoosedescription: "Long-distance road trips become easier to organize when the entire group travels in one spacious vehicle. Luxury Urbania is suitable for Maharashtra destinations, nearby states, pilgrimage routes, family holidays, and multi-day group tours."
},
{
WhyChooseheading: "Professional Driver Support",
WhyChoosedescription: "Driver-assisted transportation allows passengers to focus on their event, business schedule, family plans, or holiday rather than managing highway driving themselves. This is particularly useful for groups unfamiliar with the route."
},
{
WhyChooseheading: "Flexible for Different Travel Requirements",
WhyChoosedescription: "Luxury Force Urbania can be planned for local Pune transfers, airport pickups, weddings, corporate events, family trips, group tours, one-way journeys, and round trips. The vehicle and itinerary can be selected according to the group's specific travel needs."
}
]
};











const faqData = [
{
question: "How can I hire a Luxury Force Urbania on rent in Pune?",
answer: "Customers can enquire about a Luxury Force Urbania by sharing the pickup location, travel date, passenger count, destination, rental duration, and preferred schedule. Ruturaj Enterprises can discuss the vehicle arrangement according to the group's travel plans, whether the requirement is for local Pune travel or an outstation journey."
},
{
question: "What makes a Luxury Force Urbania suitable for group travel in Pune?",
answer: "A Luxury Force Urbania can be considered by groups looking for a more comfortable and spacious travel arrangement. It is suitable for family tours, corporate movements, weddings, airport transfers, sightseeing programs, events, and longer journeys where several passengers need to travel together."
},
{
question: "Can I rent a Luxury Force Urbania for outstation trips from Pune?",
answer: "Groups can enquire about using a Luxury Force Urbania for outstation travel from Pune to destinations such as Mumbai, Goa, Mahabaleshwar, Shirdi, Nashik, Kolhapur, and other cities. The route, travel dates, number of passengers, stay duration, and return schedule can be discussed in advance."
},
{
question: "Is Luxury Force Urbania available for weddings in Pune?",
answer: "Wedding families and event organizers can consider a Luxury Force Urbania for guest transportation between homes, hotels, wedding venues, reception halls, railway stations, and airports. The vehicle can be planned around the function timings, guest count, pickup points, and complete wedding itinerary."
},
{
question: "Can companies hire a Luxury Force Urbania in Pune?",
answer: "Corporate organizations can arrange a Luxury Force Urbania for conferences, employee transportation, business meetings, team outings, training programs, corporate events, and company tours. Sharing the number of employees, pickup locations, destination, and travel schedule helps in planning the group transportation."
},
{
question: "Can I hire a Luxury Force Urbania for Pune airport transfers?",
answer: "A Luxury Force Urbania can be used for group airport transfers involving families, corporate teams, wedding guests, or tour parties. Customers can provide the flight schedule, passenger count, luggage requirements, pickup location, and destination so the airport transportation can be coordinated with the group's timings."
},
{
question: "Is Luxury Force Urbania suitable for Pune sightseeing?",
answer: "Groups planning to explore Pune can enquire about a Luxury Force Urbania for local sightseeing. The itinerary may include historical attractions, cultural locations, shopping areas, dining stops, and other places selected by the group, with the vehicle arranged according to the planned sightseeing schedule."
},
{
question: "Can I rent a Luxury Force Urbania for a family tour?",
answer: "Large families can consider a Luxury Force Urbania when planning holidays, reunions, religious trips, or sightseeing programs. Travelling together in one dedicated vehicle can simplify coordination between family members while allowing the group to follow a common route and schedule."
},
{
question: "Can a Luxury Force Urbania be hired for corporate and social events?",
answer: "Event organizers can enquire about a Luxury Force Urbania for conferences, exhibitions, social gatherings, private functions, group celebrations, and organized events. The rental schedule can be planned according to venue timings, guest movements, pickup points, and the required duration of transportation."
},
{
question: "What details are needed to book a Luxury Force Urbania in Pune?",
answer: "To discuss a Luxury Force Urbania rental, customers can share their pickup location, journey date, destination, passenger count, travel duration, preferred reporting time, and return requirements. Additional details about airport transfers, multiple stops, sightseeing, wedding functions, or outstation travel can also be provided to Ruturaj Enterprises."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Nikhil Bhosale",
feedback:
"We needed a comfortable group vehicle for a corporate team outing from Pune and decided to hire a Luxury Force Urbania from Ruturaj Enterprises. The larger vehicle worked well for keeping the entire team together during the trip, and coordinating the pickup and return schedule was straightforward.",
rating: 5
},
{
id: 2,
name: "Miss. Priyanka Shinde",
feedback:
"For a family celebration in Pune, we had relatives arriving from different locations and needed one vehicle for several transfers. We arranged a Luxury Force Urbania through Ruturaj Enterprises for hotel, venue, and station movements. Having a dedicated group vehicle made the day's transportation much easier to organize.",
rating: 5
}
];








































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Force Urbania On Rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/luxury-force-urbania-on-rent-in-pune.webp",
  "description": "Luxury Force Urbania On Rent in Pune from Ruturaj Enterprises is a spacious premium travel option for families, corporate teams, wedding groups, airport transfers and passengers planning comfortable local or outstation journeys. Luxury Force Urbania Rental Pune, Luxury Force Urbania Hire Pune and Luxury Force Urbania Booking Pune are suitable for planned group transportation where passengers prefer travelling together in a dedicated luxury vehicle. Luxury Urbania Traveller on Rent Pune and Luxury Urbania Van Rental Pune provide convenient options for different travel requirements, while Luxury 13 Seater Urbania Pune, Luxury 14 Seater Urbania Pune, Luxury 17 Seater Urbania Pune and Luxury 20 Seater Urbania Pune allow customers to select a suitable seating capacity according to their group size. Force Urbania for Outstation Pune is suitable for longer intercity journeys, weekend trips and multi-day travel plans. Luxury Urbania for Family Trip Pune and Luxury Urbania for Group Travel Pune provide spacious transportation for holidays, sightseeing and family occasions. Luxury Urbania for Wedding Pune can be used for transporting wedding guests and family members, while Luxury Urbania for Corporate Events Pune is suitable for employee groups, business events and corporate transportation. Luxury Urbania for Airport Pickup Pune provides a comfortable option for group airport transfers and scheduled pickups. Luxury Urbania Traveller Hire Pune and Luxury Force Urbania for Outstation Travel can be arranged according to the destination, duration and passenger requirements. Customers searching for Luxury Force Urbania Rental Near Me Pune can enquire about vehicle availability and pickup locations, while Luxury Urbania Booking in Pune provides a convenient way to plan local and outstation group travel. Luxury Force Urbania Price Pune may vary according to seating capacity, distance, trip duration, route and travel requirements, allowing customers to select an option suited to their planned journey.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/luxury-force-urbania-on-rent-in-pune"
  }
};


    return (
        <div>


<Helmet>
  <title>
    Luxury Force Urbania On Rent in Pune | 13, 14, 17 & 20 Seater Premium Traveller | +91 9763381382
  </title>

  <meta
    name="description"
    content="Luxury Force Urbania On Rent in Pune by Ruturaj Enterprises for family trips, group travel, weddings, corporate events, airport pickups and outstation journeys."
  />

  <meta
    name="keywords"
    content="Luxury Force Urbania On Rent in Pune, Luxury Force Urbania Rental Pune, Luxury Force Urbania Hire Pune, Luxury Force Urbania Booking Pune, Luxury Urbania Traveller on Rent Pune, Luxury Urbania Van Rental Pune, Luxury 13 Seater Urbania Pune, Luxury 14 Seater Urbania Pune, Luxury 17 Seater Urbania Pune, Luxury 20 Seater Urbania Pune, Force Urbania for Outstation Pune, Luxury Urbania for Family Trip Pune, Luxury Urbania for Group Travel Pune, Luxury Urbania for Wedding Pune, Luxury Urbania for Corporate Events Pune, Luxury Urbania for Airport Pickup Pune, Luxury Urbania Traveller Hire Pune, Luxury Force Urbania for Outstation Travel, Luxury Force Urbania Rental Near Me Pune, Luxury Urbania Booking in Pune, Luxury Force Urbania Price Pune, Force Urbania Rental Pune, Force Urbania Hire Pune, Force Urbania Traveller Pune, Force Urbania 13 Seater Pune, Force Urbania 14 Seater Pune, Force Urbania 17 Seater Pune, Force Urbania 20 Seater Pune, Premium Urbania Rental Pune, Premium Urbania Traveller Pune, AC Luxury Urbania Pune, Luxury Urbania with Driver Pune, Urbania Corporate Travel Pune, Urbania Wedding Rental Pune, Luxury Urbania Airport Transfer Pune, Luxury Urbania Outstation Rental Pune, Luxury Urbania Family Tour Pune, Luxury Urbania Group Tour Pune, Urbania Rental Near Me Pune, Force Urbania Per Km Rate Pune, Luxury Traveller Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/114.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxuryforceurbania;